<pin-dialog class="pin-confirm-dialog">
  <pin-dialog-title data-testid="confirm-dialog-title">{{title}}</pin-dialog-title>

  <pin-dialog-content>
    <p class="dcp-body pb-2" data-testid="confirm-dialog-subheading">
      {{subheading}}
    </p>
  </pin-dialog-content>

  <pin-dialog-actions>
  <div class="flex flex-col-reverse w-full md:flex-row md:justify-end md:items-center gap-6 md:w-auto">
        <pin-button buttonId="confirm-dialog-cancel-link" buttonStyle="link" buttonTabIndex="0" (buttonClick)="cancel()">
			    CANCEL
		    </pin-button>
      <pin-button buttonId="confirm-dialog-confirm-button" buttonStyle="filled" buttonTabIndex="0" (buttonClick)="confirm()">{{ confirmLabel ? confirmLabel : 'CONFIRM' }}</pin-button>
    </div>
  </pin-dialog-actions>
</pin-dialog>
